import { Dispatch, SetStateAction, createContext } from 'react';

import { HEALTH, TERM } from '../../common/constants';
import { AllSlots, CustomerAppointment, CustomerEventDetails } from '../../types';

const initialValues: CustomerAppointment = {
  timezone: '',
  type: '',
  user_name: '',
  phone_num: null,
  email: '',
  date: '',
  time: '',
  query: '',
  cust_source_v1: ''
};

type AppointmentContextType = {
  step: number;
  loadingEventData: boolean;
  loadingSlots: boolean;
  eventData: CustomerEventDetails | null;
  appointmentData: CustomerAppointment;
  duplicateAppointment: CustomerAppointment | null;
  datewiseSlots: AllSlots | null;
  prevAppointment: CustomerAppointment | null;
  renderWhatsappForm: boolean;
  isRescheduling: boolean;
  slotBookError: string | null;
  isLiveCall: boolean;
  setStep: Dispatch<SetStateAction<number>>;
  handleWhatsappClick: (vertical?: typeof HEALTH | typeof TERM) => void;
  setAppointmentData: Dispatch<SetStateAction<CustomerAppointment>>;
};

export const AppointmentContext = createContext<AppointmentContextType>({
  step: 0,
  loadingEventData: false,
  loadingSlots: false,
  eventData: null,
  appointmentData: initialValues,
  duplicateAppointment: null,
  datewiseSlots: null,
  prevAppointment: null,
  renderWhatsappForm: false,
  isRescheduling: false,
  slotBookError: null,
  isLiveCall: false,
  setStep: () => null,
  handleWhatsappClick: () => null,
  setAppointmentData: () => null
});
